module.exports = __webpack_public_path__ + "img/Ana-Maria-Gallardo-Montero.3b0d9ebd.jpg";